import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { forEach } from 'lodash'
import { Map } from 'immutable'
import shortid from 'shortid'
import * as forms from './form'
import LabeledRowOutput from './LabeledRowOutput'
import { CONNECTED_INPUT_LABEL_KEY } from './FormattedConnectedInput'
/**
 * Smart component for rendering a list of numbers from the redux store and
 * associated labels
 */
class DisplayDynamicList extends Component {
  /**
   *
   */
  render () {
    return (
      <div>
        {this.props.stateMap
          .entrySeq()
          .map(e => (
            <LabeledRowOutput
              key={e[0] || shortid.generate()}
              label={e[0] || '-'}
              output={e[1]}
              altLayout={this.props.altLayout}
            />
          ))}
      </div>
    )
  }
}

DisplayDynamicList.propTypes = {
  reduxFormLinesKey: PropTypes.string.isRequired,
  sectionNumber: PropTypes.number.isRequired,
  altLayout: PropTypes.bool
}

export function mapStateToProps (state, ownProps) {
  const formLines = state.get('app').get(ownProps.reduxFormLinesKey)
  const formKeys = forms.getFormKeysArray(ownProps.sectionNumber, formLines)
  let stateMap = Map({})
  forEach(formKeys, formKey => {
    const label = state.get('forms').get(formKey + CONNECTED_INPUT_LABEL_KEY)
    const val = state.get('forms').get(formKey)
    stateMap = stateMap.set(label, val)
  })
  return {
    stateMap
  }
}

export default connect(mapStateToProps)(DisplayDynamicList)



// WEBPACK FOOTER //
// ./src/components/forms/DisplayDynamicList.js